import { Box, Button, Card, Fab, IconButton } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import { Delete } from "@material-ui/icons";
import CreateIcon from "@mui/icons-material/Create";
import { Dialog, DialogActions, DialogTitle, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { City, Country, State } from "country-state-city";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import {
  errorAddEvent,
  errorFetchEvents,
  errorSnackbar,
  successSnackbar
} from "../../actions/snackbarActions";
import { Endpoint, Status } from "../../apis/apiConstants";
import AjaxHelper from "../../apis/apiRequest";
import MAutocomplete from "../../components/MAutocomplete";
import MTextField from "../../components/MTextField";
import NodataComponent from "../../components/NodataComponent";
import {
  ResponsiveDialogActions,
  SnackbarType,
} from "../../constants/appConstants";
import { getCopy } from "../../helpers/utils.helper";
import { setSnackbar } from "../../reducers/snackbarReducer";
import "./events.scss";

import { Container } from "@material-ui/core";

import { format, getMonth, getYear } from "date-fns";
import { USER_TYPE } from "../../common/constants";
import MonthYearCalendar from "../../components/MonthPicker/MonthPicker";
import SessionDetails from "../../helpers/sessionDetails";
import { setResponsiveDialog } from "../../reducers/responsiveDialogReducer";

const formFields = require("./eventfileds.json");

export default function Event() {
  const [formData, setFormData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [events, setEvents] = useState([]);
  const [formDataPages, setFormDataPages] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState(new Date());

  const [location, setLocation] = useState({
    country: Country.getAllCountries(),
    state: State.getStatesOfCountry("IN"),
    city: City.getCitiesOfState("IN", "MH"),
  });
  const [locationOptions, setLocationOptions] = useState({
    country: {},
    state: {},
    city: {},
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  React.useEffect(() => {
    getAllEvents();
  }, [selectedMonth]);

  const isAuthorizedToManage = () => {
    return (
      SessionDetails.getCurrentUser().userType.includes(
        USER_TYPE.MASTER_ADMIN
      ) ||
      SessionDetails.getCurrentUser().userType.includes(
        USER_TYPE.JAMAT_ADMIN
      ) ||
      SessionDetails.getCurrentUser().userType.includes(USER_TYPE.EVENT_ADMIN)
    );
  };

  const getAllEvents = () => {
    dispatch(startLoading);
    AjaxHelper.getApi(
      navigate,
      Endpoint.GET_MONTH_EVENTS,
      {},
      { month: getMonth(selectedMonth), year: getYear(selectedMonth) }
    )
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          setFormData(response.data.data);
        } else {
          dispatch(
            setSnackbar(true, SnackbarType.ERROR, response.data.message)
          );
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
        dispatch(errorFetchEvents);
      });
  };
  const deleteEvent = (_id) => {
    dispatch(startLoading);
    AjaxHelper.postApi(navigate, Endpoint.DELETE_EVENTS + `/${_id}`)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          dispatch(
            setSnackbar(true, SnackbarType.SUCCESS, response.data.message)
          );
          getAllEvents();
        } else {
          dispatch(
            setSnackbar(true, SnackbarType.ERROR, response.data.message)
          );
        }
      })
      .catch(() => {
        dispatch(stopLoading);
        setSnackbar(true, SnackbarType.ERROR);
      });
  };

  const getFormDataView = () => {
    if (!Array.isArray(formData)) {
      return null;
    }

    return formData.map((e) => (
      <Card className="eventCard" key={e._id} variant="outlined">
        <div
         className="cardBody"
        >
          <div className="cardDate">
            <div className="font-bold font-16">{e.title}</div>
            <div className="font-medium font-14">{e.description}</div>
            <div>
              <span className={"font-medium"}>
                {e.dateFrom ? format(new Date(e.dateFrom), "dd MMM yyyy") : "-"}
              </span>

              {e.dateFrom === e.dateTo ? null : (
                <>
                  <span className={"font-medium"}> - </span>
                  <span className={"font-medium"}>
                    {e.dateTo ? format(new Date(e.dateTo), "dd MMM yyyy") : "-"}
                  </span>
                </>
              )}
            </div>
            <div>
              <span className="font-bold">{"Venue: "}</span>
              <span className="font-medium">
                {e.city && e.state && e.country
                  ? `${e.city}, ${e.state}, ${e.country}`
                  : "-"}
              </span>
            </div>
          </div>
          {isAuthorizedToManage() ? (
            <div>
              <Tooltip title={"delete"}>
                <IconButton
                  onClick={(event) => {
                    event.preventDefault();
                    dispatch(
                      setResponsiveDialog(
                        true,
                        "Delete Event",
                        "Do you want to delete?",
                        "Yes",
                        "No",
                        (action) => {
                          if (action === ResponsiveDialogActions.POSITIVE) {
                            deleteEvent(e._id);
                          }
                        }
                      )
                    );
                  }}
                >
                  <Delete color="error" />
                </IconButton>
              </Tooltip>
            </div>
          ) : null}
        </div>
      </Card>
    ));
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    event.preventDefault();
    let updateEvent = getCopy(formData);
    updateEvent[event.target.name] = event.target.value;
    setFormData(updateEvent);
  };

  const getEventFormFields = () => {
    return formFields.map((field) => {
      if (
        field.type === "text" ||
        field.type === "email" ||
        field.type === "number"
      ) {
        return (
          <div
            className={`${
              field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-12 col-lg-12 col-md-12"
            } col-12 d-flex justify-content-center align-items-center`}
            key={field.key}
          >
            <MTextField
              id={field.key}
              name={field.key}
              className="col-12"
              type={field.type}
              required={field.required}
              label={field.label}
              multiline={field.multiline ?? false}
              value={formData[field.key]}
              onChange={handleChange}
              placeholder={field.placeholder}
            />
          </div>
        );
      } else if (field.type === "date") {
        const isStartDate = field.key === "dateFrom";
        const correspondingEndDateKey = "dateTo";

        return (
          <div
            className={`${
              field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-3 col-lg-6 col-md-12"
            } col-12 d-flex justify-content-center align-items-center`}
            key={field.key}
          >
            <MTextField
              id={field.key}
              name={field.key}
              type="date"
              className="col-12"
              required={field.required}
              label={field.label}
              value={formData[field.key]}
              onChange={(e) => {
                const selectedDate = e.target.value;
                setFormData((prevData) => ({
                  ...prevData,
                  [field.key]: selectedDate,
                  ...(isStartDate && {
                    [correspondingEndDateKey]: selectedDate,
                  }),
                }));
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        );
      } else if (
        field.type === "country" ||
        field.type === "state" ||
        field.type === "city"
      ) {
        return (
          <div
            className={`${
              field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-3 col-lg-6 col-md-12"
            } col-12 d-flex justify-content-center align-items-center`}
            key={field.key}
          >
            <MAutocomplete
              id={field.key}
              value={locationOptions[field.key]}
              inputValue={formData[field.key]}
              onInputChange={(event, newInputValue) => {
                const updateEvent = { ...formData };
                updateEvent[field.key] = newInputValue;
                setFormData(updateEvent);
              }}
              size="medium"
              className="input"
              required={field.required}
              options={location[field.type]}
              onChange={(event, newValue) =>
                handleDropdownChange(newValue, field.type)
              }
              placeholder={field.placeholder}
              label={field.label}
            />
          </div>
        );
      } else {
        return null;
      }
    });
  };

  const getCities = (country, state) => {
    AjaxHelper.getApi(navigate, Endpoint.GET_CITIES, null, {
      state: state,
      country: country,
    })
      .then((response) => {
        if (
          response.data.status === Status.API_SUCCESS ||
          response.data.status === Status.API_NO_CONTENT
        ) {
          let city = City.getCitiesOfState(country, state);
          let newCities = city.concat(response.data.data);
          let updatedLocation = getCopy(location);
          updatedLocation.city = newCities;
          setLocation(updatedLocation);
        } else {
          // dispatch(errorRegisterUser);
        }
      })
      .catch((err) => {
        // dispatch(errorRegisterUser);
      });
  };

  const handleDropdownChange = (value, type) => {
    let updateEvent = getCopy(formData);
    let updatedLocation = getCopy(location);
    const updatedLocationOptions = getCopy(locationOptions);
    updatedLocationOptions[type] = value;

    let cityApiCalled = false;
    switch (type) {
      case "country":
        updateEvent.country = value.name;
        updateEvent.countryCode = value.isoCode;
        updateEvent.state = "";
        updateEvent.city = "";
        updatedLocation.state = State.getStatesOfCountry(
          updateEvent.countryCode
        );
        updatedLocation.city = [];
        break;
      case "state":
        updateEvent.state = value.name;
        updateEvent.stateCode = value.isoCode;
        updateEvent.city = "";
        updatedLocation.city = [];
        cityApiCalled = true;
        break;
      case "city":
        updateEvent.city = value.name;
        break;
      default:
        break;
    }
    setFormData(updateEvent);
    setLocation(updatedLocation);
    setLocationOptions(updatedLocationOptions);
    if (cityApiCalled) {
      getCities(updateEvent.countryCode, updateEvent.stateCode);
    }
  };

  const addEvent = () => {
    handleClose();
    dispatch(startLoading);
    AjaxHelper.postApi(navigate, Endpoint.ADD_EVENTS, formData)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_CREATED) {
          // dispatch(successAddEvent);
          dispatch(successSnackbar(response.data.message));
          getAllEvents();
        } else {
          dispatch(errorSnackbar(response.data.message));
          // dispatch(errorAddEvent);
          getAllEvents();
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorAddEvent);
      });
  };

  return (
    <div className={"notification-component d-flex flex-column p-md-3"}>
      <div>
        <Box className="d-flex flex-row justify-content-center align-content-center">
          <MonthYearCalendar
            value={selectedMonth}
            onChange={(date) => setSelectedMonth(date)}
          />
        </Box>
        <Container className="content-container">
          {getFormDataView()}
          {formData.length > 0 ? null : <NodataComponent />}
        </Container>
      </div>
      {isAuthorizedToManage() ? (
        <Box className="eventSectionFabButton">
          <Fab
            className="eventFabButton"
            onClick={() => {
              setFormData({});
              setLocationOptions({});
              handleClickOpen();
            }}
          >
            <CreateIcon />
          </Fab>
        </Box>
      ) : null}

      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogTitle className={"background-color-head"}>
          <span className={"font-bold font-18"}>Event form</span>
        </DialogTitle>
        <Divider />

        <div className={"jamaat-form"}>{getEventFormFields()}</div>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={() => addEvent()}>{"Add"}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
